export default __webpack_public_path__ + "static/media/logo_w.78e61826.png";